export const Breakpoint = {
  MOBILE: "@media only screen and (max-width: 480px)",
  TABLET: "@media only screen and (max-width: 900px)",
  LAPTOP: "@media only screen and (max-width: 1180px)",
  DESKTOP: "@media only screen and (min-width: 1180px)",
  TABLET_ONLY:
    "@media only screen and (max-width: 900px) and (min-width: 480px)",
};
